import React, {useState, Component } from 'react'
import { Card, notification, Form, Tag, Popconfirm, Button } from 'antd'
import { connect } from 'react-redux'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils-lite'
import { DisplayDate } from '../../../components/_utils/appUtils'
import ReactHtmlParser from 'react-html-parser'
import Request from '../../../request'
import SubmissionErrorsDrawer from './SubmissionErrorsDrawer';
import SubmissionErrorFullDetailsDrawer from './SubmissionErrorFullDetailsDrawer'
import { listSubmissionErrors,deleteSubmissionErrors } from '../actions'
const RenderAbstract = ({ content }) => {
  const [hideV, setHideV] = useState(true);

  if (!content) return <span>N/A</span>;

  const plainText = content.replace(/<[^>]+>/g, '');
  const limit = 150;

  return (
    <div>
      {hideV && plainText.length > limit ? (
        <span>{plainText.substring(0, limit)}...</span>
      ) : (
        <div>{ReactHtmlParser(content)}</div>
      )}

      {plainText.length > limit && (
        <div style={{ textAlign: 'right', marginTop: '4px' }}>
          <a
            style={{ fontSize: '12px', color: '#1890ff' }}
            onClick={(e) => {
              e.stopPropagation();
              setHideV(!hideV);
            }}
          >
            {hideV ? 'Show More' : 'Show Less'}
          </a>
        </div>
      )}
    </div>
  );
};
@Form.create()
class RawSubmissions extends Component {
  state = {
    total: '',
    filters: {},
    visibleErrorDrawer: false,
    selectedRecord: null,
    submissionDrawerVisible: false,
    drawerData: null
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let obj = { ...params, ...this.state.filters }
      let data = await listSubmissionErrors(obj)

      this.setState({ total: data.total })
      resolve(data)
    })
  }
  reload = () => {
    this.table.current.reload()
  }
  handleDelete = async (id) => {
    let resp = await deleteSubmissionErrors(id);
    if (resp && !resp.error) {
      this.reload();
    }
  }
  render() {
    const columns = [
      // {
      //   title: 'S.No',
      //   key: 'serialNo',
      //   dataIndex: 'serialNo',
      //   width: 80,
      //   render: (text) => text ? text : 'N/A'
      // },
      {
        title: 'S.No',
        key: 'index',
        width: 80,
        render: (text, record, index) => {
          return <div className={'alignCenter'}>{index + 1}</div>
        }
      },
      {
        title: 'Submission Date',
        key: 'intakeTimestamp',
        dataIndex: 'intakeTimestamp',
        render: (text, record) => record.intakeTimestamp ? DisplayDate(record.intakeTimestamp) : null
      },
      // {
      //   title: 'Status',
      //   key: 'status',
      //   dataIndex: 'status',
      //   render: (text, record) => (
      //     <Tag color={record.status === 'RECEIVED' ? 'green' : 'blue'}>{record.status}</Tag>
      //   )
      // },
      // {
      //   title: 'Manuscript Title',
      //   key: 'titleOfAbstract',
      //   render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.titleOfAbstract : 'N/A'
      // },
      {
        title: 'Manuscript Title',
        key: 'titleOfAbstract',
        render: (text, record) => {
          const title = (record && record.rawBody && record.rawBody.abstract && record.rawBody.abstract.titleOfAbstract)
            ? record.rawBody.abstract.titleOfAbstract
            : 'N/A';

          return title !== 'N/A' ? (
            <a onClick={() => this.setState({ submissionDrawerVisible: true, drawerData: record })}>
              {title}
            </a>
          ) : 'N/A'
        }
      },
      // {
      //   title: 'Abstract',
      //   key: 'abstract',
      //   render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.abstract : 'N/A'
      // },
      // {
      //   title: 'Abstract',
      //   key: 'abstract',
      //   render: (text, record) => {
      //     const abstractContent = (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.abstract : null;
      //
      //     return abstractContent ? (
      //       <div>
      //         {ReactHtmlParser(abstractContent)}
      //       </div>
      //     ) : 'N/A';
      //   }
      // },
      {
        title: 'Abstract',
        key: 'abstract',
        render: (text, record) => {
          const abstractContent = (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.abstract : null;

          return abstractContent ? (
            <RenderAbstract content={abstractContent} />
          ) : 'N/A';
        }
      },
      // {
      //   title: 'Author',
      //   key: 'authorName',
      //   render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.authorName : 'N/A'
      // },
      // {
      //   title: 'Email',
      //   key: 'email',
      //   render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.email : 'N/A'
      // },
      {
        title: 'Author',
        key: 'correspondingAuthor',
        dataIndex: 'correspondingAuthor',
        render: (text) => text ? text : 'N/A'
      },
      {
        title: 'Email',
        key: 'correspondingAuthorsEmail',
        dataIndex: 'correspondingAuthorsEmail',
        render: (text) => text ? text : 'N/A'
      },
      {
        title: 'Journal/Event',
        key: 'journal',
        render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.journal : 'N/A'
      },
      {
        title: 'Errors',
        key: 'errors',
        width: 120,
        align: 'center',
        render: (text, record) => {
          const errorCount = (record.errorDetails && Array.isArray(record.errorDetails)) ? record.errorDetails.length : 0;
          return (
            <Button
              className='roundSmallBtn'
              onClick={() => this.setState({ visibleErrorDrawer: true, selectedRecord: record })}
            >
              View ({errorCount})
            </Button>
          );
        }
      },
      {
        title: 'Actions',
        key: 'actions',
        width: 160,
        align: 'center',
        render: (text, record) => (
          <Popconfirm
            placement="bottom"
            title={`Are you sure you want to delete this Submission ?`}
            onConfirm={() => this.handleDelete(record._id)}
            okText='Yes' cancelText='No'
          >
            <Button className='roundSmallBtn2'>Delete</Button>
          </Popconfirm>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={`Submissions Errors (${this.state.total})`}>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
          />
        </Card>
        {this.state.visibleErrorDrawer && (
          <SubmissionErrorsDrawer
            visible={this.state.visibleErrorDrawer}
            record={this.state.selectedRecord}
            onClose={() => this.setState({ visibleErrorDrawer: false, selectedRecord: null })}
          />
        )}
        {this.state.submissionDrawerVisible && (
          <SubmissionErrorFullDetailsDrawer
            visible={this.state.submissionDrawerVisible}
            data={this.state.drawerData}
            onClose={() => this.setState({ submissionDrawerVisible: false, drawerData: null })}
          />
        )}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({ categories: global.categories })
const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(RawSubmissions)